var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHardMuteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F12C3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23C17.791 23 16 21.209 16 19V14C16 11.791 17.791 10 20 10C22.209 10 24 11.791 24 14V19C24 21.209 22.209 23 20 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.057 21.0161C26.389 20.8251 25.657 21.1081 25.341 21.7271C24.348 23.6691 22.331 25.0001 20 25.0001C17.669 25.0001 15.652 23.6691 14.66 21.7271C14.344 21.1081 13.612 20.8251 12.944 21.0161C12.033 21.2761 11.584 22.3111 12.022 23.1511C13.223 25.4591 15.4 27.1611 18.001 27.7551V28.0001C18.001 29.1051 18.896 30.0001 20.001 30.0001C21.106 30.0001 22.001 29.1051 22.001 28.0001V27.7551C24.602 27.1611 26.779 25.4591 27.98 23.1511C28.417 22.3111 27.968 21.2761 27.057 21.0161Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0002 30C28.7442 30 28.4882 29.902 28.2932 29.707L10.2932 11.707C9.90225 11.316 9.90225 10.684 10.2932 10.293C10.6842 9.90201 11.3162 9.90201 11.7072 10.293L29.7073 28.293C30.0983 28.684 30.0983 29.316 29.7073 29.707C29.5123 29.902 29.2563 30 29.0002 30Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardMuteIcon);
export default __webpack_public_path__ + "static/media/hard-mute-icon.0b93cffe8acee635b1359907c6813ef5.svg";
export { ForwardRef as ReactComponent };